export default "__VITE_ASSET__79eed368__"